/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Avatar1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Avatar1({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsRelationshipsItem/Avatar",
  presignedUrl
  
}) {
let professionalOtherPersonValueData = fromData.useDataFormat({ viewPath,
context: 'professional',
path: 'other.person',
format: fromFormat.initials,
})
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="professional.other.person"
 format="/Data/format.js initials"
 initials={professionalOtherPersonValueData}
/>
{children}
</React.Fragment>)
}